import React, { useEffect, useState } from "react"
import { Button, Card } from "react-bootstrap"
import { useTranslation } from "react-i18next"
import { useDispatch, useSelector } from "react-redux"
import swal from "sweetalert"
import { CardBody } from "../../../../../_metronic/_partials/controls/index.js"
import { useSubheader } from "../../../../../_metronic/layout/index.js"
import { ErpNumber } from "../../../../../component/atoms/ErpNumber/ErpNumber.jsx"
import { Popup, PopupQuestion } from "../../../../../component/atoms/Popup/index.jsx"
import { RowModule } from "../../../../../component/atoms/RowModule/RowModule.jsx"
import { DetailText, InlineText, RowText, Status } from "../../../../../component/index.jsx"
import { ActivityDetailHeader } from "../../../../../component/molecule/ActivityDetailHeader/ActivityDetailHeader.jsx"
import { ICON_CONSTANTS, ILLUSTRATION_CONSTANTS } from "../../../../../constants/ImageConstants.js"
import { AREA, GENERAL } from "../../../../../constants/InitTypeConstants.js"
import { RoutesConstants } from "../../../../../constants/RoutesConstants.js"
import {
  activitySendToErp,
  getDetailTillage,
  updateAreaActivityImage
} from "../../../../../redux/actions/AreaAction.jsx"
import { timeStampToDate } from "../../../../helpers/DateHelper.js"
import {
  checkBadgePaymentStatus,
  stringFormatting,
  toMeter,
  toRupiah
} from "../../../../helpers/TextHelper.js"
import {
  ACTIVITY_METHODE_ENUM,
  ACTIVITY_STATUS_ENUM,
  DATE_TYPE_ENUM,
  MACHINE_OWNER_TYPE_ENUM,
  STATUS_VARIANT_CONSTANT
} from "../../../../../constants/StringConstant.js"

export const TillageDetail = ({
  match: {
    params: { status, id, activity_id }
  }
}) => {
  const subHeader = useSubheader()
  const dispatch = useDispatch()
  const { t } = useTranslation()
  const { MasterData, General, Area } = useSelector((state) => state)
  const [detail, setDetail] = useState({})
  const [showPopup, setShowPopup] = useState(false)
  const [popupContent, setPopupContent] = useState({})
  const [idDocument, setIdDocument] = useState(null)
  const [showModalDialog, setShowModalDialog] = useState(false)

  const btnApprove = (
    <Button className={"btn btn-primary"} onClick={() => setShowModalDialog(true)}>
      {t("button_send_to_finance")}
    </Button>
  )

  useEffect(() => {
    dispatch(getDetailTillage(activity_id))
  }, [])

  useEffect(() => {
    if (Area.data) {
      setDetail(Area.data)
    }
  }, [Area])

  useEffect(() => {
    if (detail) {
      if (detail?.is_confirmed_erp === false) {
        subHeader.setButton(btnApprove)
      } else {
        subHeader.setButton(null)
      }

      subHeader.setBreadcrumbs([
        {
          pathname: RoutesConstants.AREA.LIST_AREA_TEREGISTRASI(status),
          title: t("label_area_name")
        },
        {
          pathname: RoutesConstants.AREA.LIST_AREA_TEREGISTRASI(status),
          title: t("label_registered")
        },
        {
          pathname: RoutesConstants.AREA.DETAIL_AREA(status, id),
          title: detail?.activity_detail_response?.area_name
        },
        {
          title: "Olah Tanah"
        }
      ])
    }
  }, [detail])

  useEffect(() => {
    if (General.isFinishUpdateOrDelete) {
      if (General.actionInitType === GENERAL.UPLOAD) {
        const data = {
          id: detail?.activity_detail_response?.image_and_id_activity[idDocument]?.id,
          url: MasterData.urlResponseUpload
        }

        dispatch(updateAreaActivityImage(data))
      } else if (General.actionInitType === AREA.UPDATE_ACTIVITY_IMAGE) {
        dispatch(getDetailTillage(activity_id))
      } else if (
        General.loading === false &&
        General.actionInitType === AREA.APPROVE_ACTIVITY_TO_ERP
      ) {
        setShowModalDialog(false)
        swal({
          icon: ILLUSTRATION_CONSTANTS.SUCCESS_FORM,
          text: t("messages_response_activity_approve_to_erp_success")
        })
        dispatch(getDetailTillage(activity_id))
      }
    }
  }, [General])

  const titleActivity = (
    <ActivityDetailHeader
      icon={ICON_CONSTANTS.ACTIVITY_ICONS.TILLAGE}
      title={` AKTIVITAS Olah Tanah KE-${detail?.activity_detail_response?.seq}`}
      bottomContent={
        <ErpNumber
          noFaktur={detail?.no_faktur}
          noOrderSj={detail?.no_order_sj}
          noOrderSpk={detail?.no_order_spk}
          noOrderErp={detail?.no_order_erp}
          status={detail?.activity_type_enum}
        />
      }
      rightContent={
        detail?.is_confirmed_erp !== null && (
          <Status
            text={detail?.activity_status_string}
            variant={
              detail?.activity_status_enum === ACTIVITY_STATUS_ENUM.APPROVED
                ? STATUS_VARIANT_CONSTANT.COMPLETED
                : STATUS_VARIANT_CONSTANT.WARNING
            }
          />
        )
      }
    />
  )

  const openPopup = (content) => {
    setPopupContent(content)
    setShowPopup(true)
  }

  const bodyPopup = (
    <RowModule customColumnCss={"col-md-12 mb-2"}>
      <RowModule>
        <InlineText
          type={"between"}
          title={t("label_id_alsintan")}
          value={popupContent?.machine_code ? popupContent?.machine_code : "-"}
        />
      </RowModule>
      <RowModule>
        <InlineText
          type={"between"}
          title={t("label_owner_name")}
          value={popupContent?.owner_name ? popupContent?.owner_name : "-"}
        />
      </RowModule>
      <RowModule>
        <InlineText
          type={"between"}
          title={t("label_machine_owner")}
          value={
            popupContent?.supplier_enum === MACHINE_OWNER_TYPE_ENUM.THIRD_PARTY ||
            popupContent?.supplier_enum === MACHINE_OWNER_TYPE_ENUM.OTHER_FARMER ||
            popupContent?.supplier_enum === MACHINE_OWNER_TYPE_ENUM.OTHER_MITRA ||
            popupContent?.supplier_enum === MACHINE_OWNER_TYPE_ENUM.OTHER_VENDOR
              ? "Pihak ke-3" + " - " + popupContent?.supplier_third_party_string
              : stringFormatting(popupContent?.supplier_name)
          }
        />
      </RowModule>
      <RowModule>
        <InlineText
          type={"between"}
          title={t("label_machine_name")}
          value={popupContent?.machine_name ? popupContent?.machine_name : "-"}
        />
      </RowModule>
      <RowModule>
        <InlineText
          type={"between"}
          title={t("label_chassis_number")}
          value={popupContent?.frame_number ? popupContent?.frame_number : "-"}
        />
      </RowModule>
      <RowModule>
        <InlineText
          type={"between"}
          title={t("label_machine_number")}
          value={popupContent?.engine_number ? popupContent?.engine_number : "-"}
        />
      </RowModule>
    </RowModule>
  )
  const detailActivitas = (
    <>
      <Card>
        <CardBody>
          <h4 className={"mb-6 text-uppercase"}>INFORMASI LAHAN</h4>
          <RowModule customColumnCss={"col-md-6 mb-2"}>
            <RowModule>
              <RowText
                label={t("label_area_name")}
                value={
                  detail?.area_information?.area_name ? detail?.area_information?.area_name : "-"
                }
              />
              {/*<InlineText*/}
              {/*  title={"Lahan"}*/}
              {/*  value={checkValue(list?.area_information?.area_name) }*/}
              {/*/>*/}
            </RowModule>
            <RowModule>
              <RowText
                label={t("label_manual_area_size")}
                value={
                  detail?.area_information?.area_land_manual
                    ? toMeter(detail?.area_information?.area_land_manual)
                    : "-"
                }
              />
            </RowModule>
            <RowModule>
              <RowText
                hasIcon={detail?.area_information?.has_kur}
                icon={detail?.area_information?.bank_image}
                label={t("label_farmer")}
                value={
                  detail?.area_information?.farmer_name
                    ? `${detail?.area_information?.farmer_name} (${detail?.area_information?.farmer_code})`
                    : "-"
                }
              />
            </RowModule>
            <RowModule>
              <RowText
                label={t("label_polygon_area_size")}
                value={
                  detail?.area_information?.area_land_polygon
                    ? toMeter(detail?.area_information?.area_land_polygon)
                    : "-"
                }
              />
            </RowModule>
            <RowModule>
              <RowText
                label={t("label_mitra")}
                value={
                  detail?.area_information?.mitra_name
                    ? `${detail?.area_information?.mitra_name} (${detail?.area_information?.mitra_code})`
                    : "-"
                }
              />
            </RowModule>
            <RowModule>
              <RowText
                label={t("label_plant_type")}
                value={
                  detail?.area_information?.plant_type_name
                    ? detail?.area_information?.plant_type_name
                    : "-"
                }
              />
            </RowModule>
            <RowModule>
              <RowText
                label={t("label_area_location")}
                value={
                  detail?.area_information?.full_address
                    ? detail?.area_information?.full_address
                    : "-"
                }
              />
            </RowModule>
            <RowModule>
              <RowText
                label={t("label_plant_varieties")}
                value={
                  detail?.area_information?.variety_name
                    ? detail?.area_information?.variety_name
                    : "-"
                }
              />
            </RowModule>
          </RowModule>
        </CardBody>
      </Card>
      <Card>
        <CardBody>
          <h4 className={"mb-6 mt-6 text-uppercase"}>Detail Aktivitas</h4>
          <RowModule customColumnCss={"col-md-6 mb-2"}>
            <RowModule>
              <RowText
                label={t("label_submitted_by")}
                value={
                  detail?.activity_detail_response?.submitted_by
                    ? detail?.activity_detail_response?.submitted_by
                    : "-"
                }
              />
            </RowModule>
            <RowModule>
              <RowText
                label={t("label_activity_date")}
                value={
                  detail?.activity_detail_response?.activity_date
                    ? timeStampToDate(detail?.activity_detail_response?.activity_date, "dd-MM-yyyy")
                    : "-"
                }
              />
            </RowModule>
            <RowModule>
              <RowText
                label={t("label_submitted_time")}
                value={
                  detail?.activity_detail_response?.submitted_date
                    ? timeStampToDate(
                        detail?.activity_detail_response?.submitted_date,
                        "dd-MM-yyyy HH:mm:ss"
                      )
                    : "-"
                }
              />
            </RowModule>
            <RowModule>
              <RowText
                label={"HST"}
                value={stringFormatting(detail?.activity_detail_response?.hst, "HST")}
              />
            </RowModule>

            <RowModule>
              <RowText
                label={"Olah Tanah ke"}
                value={stringFormatting(detail?.activity_detail_response?.seq)}
              />
            </RowModule>
            <RowModule>
              <RowText
                label={"Metode Olah Tanah"}
                value={stringFormatting(detail?.activity_detail_response?.activity_methode_string)}
              />
            </RowModule>
            <RowModule>
              <RowText
                label={"Requested by"}
                value={stringFormatting(detail?.activity_detail_response?.request_by_string)}
              />
            </RowModule>
            {detail?.activity_detail_response?.activity_methode_enum !==
              ACTIVITY_METHODE_ENUM.MANUAL && (
              <RowModule>
                <RowText
                  label={t("label_alsintan_land_area_worked")}
                  value={
                    detail?.activity_detail_response?.worked_area
                      ? toMeter(detail?.activity_detail_response?.worked_area)
                      : "-"
                  }
                />
              </RowModule>
            )}
          </RowModule>
          <div className={"d-flex flex-column w-100"} style={{ gap: 12 }}>
            {detail?.tools?.map((item, index) => {
              return (
                <Card bg={"secondary"} key={index}>
                  <CardBody>
                    <div className={""}>
                      <h4 className={"mb-6 text-capitalize"}>Alsintan {index + 1}</h4>
                      <RowModule customColumnCss={"col-md-6"}>
                        <RowModule customColumnCss={"col-md-12 mb-2"}>
                          <RowText
                            label={t("label_machine_owner")}
                            value={
                              item?.supplier_enum === MACHINE_OWNER_TYPE_ENUM.THIRD_PARTY ||
                              item?.supplier_enum === MACHINE_OWNER_TYPE_ENUM.OTHER_FARMER ||
                              item?.supplier_enum === MACHINE_OWNER_TYPE_ENUM.OTHER_MITRA ||
                              item?.supplier_enum === MACHINE_OWNER_TYPE_ENUM.OTHER_VENDOR
                                ? "Pihak ke-3" + " - " + item?.supplier_third_party_string
                                : stringFormatting(item?.supplier_name)
                            }
                          />
                        </RowModule>

                        <RowModule customColumnCss={"col-md-12 mb-2"}>
                          <RowText
                            label={"Operator"}
                            value={
                              item?.operators && item.operators.length
                                ? item.operators.map((e) => e.operator_name).join(", ")
                                : "-"
                            }
                          />
                        </RowModule>
                        <RowModule customColumnCss={"col-md-12 mb-2"}>
                          <RowText
                            label={"Nama Pemilik Alsintan"}
                            value={item?.owner_name ? item?.owner_name : "-"}
                          />
                        </RowModule>

                        {item?.use_implement && (
                          <RowModule customColumnCss={"col-md-12 mb-2"}>
                            <RowText
                              label={"Implement"}
                              value={stringFormatting(item?.implement_name)}
                            />
                          </RowModule>
                        )}
                        <RowModule customColumnCss={"col-md-12 mb-2"}>
                          <RowText
                            label={"Alsintan"}
                            value={`${stringFormatting(item?.machine_name)}   (${
                              item?.frame_number ? item?.frame_number : "-"
                            })`}
                          />
                        </RowModule>
                      </RowModule>
                      <RowModule customColumnCss={"col-md-12 mb-2"}>
                        <a
                          className="hover text-secondary-blue underline"
                          onClick={() => {
                            openPopup(item)
                          }}>
                          Lihat Detail
                        </a>
                      </RowModule>
                    </div>
                  </CardBody>
                </Card>
              )
            })}
          </div>

          <div className={"my-10"}>
            <h4 className={"mb-6"}>CATATAN</h4>
            <div className={"row mb-4"}>
              {detail?.activity_detail_response?.image_and_id_activity &&
                detail?.activity_detail_response?.image_and_id_activity.map((item, index) => {
                  return (
                    <div className={"col-md-3"} key={index}>
                      <DetailText
                        type="image"
                        value={item.url}
                        indexKey={index}
                        menu={AREA.ACTIVITY_TILLAGE}
                        setIdDocument={setIdDocument}
                      />
                    </div>
                  )
                })}
            </div>
            <span className="font-weight-bold text-dark-50 font-size-sm">
              {detail?.activity_detail_response?.note
                ? detail?.activity_detail_response?.note
                : "-"}
            </span>
          </div>
        </CardBody>
      </Card>
    </>
  )

  const bills = (
    <Card className={"mb-4"}>
      <CardBody>
        <div className={"d-flex justify-content-between align-items-center"}>
          <h4 className={"mb-6 text-uppercase"}>{t("details_bill")}</h4>
          {checkBadgePaymentStatus(detail?.billing_detail?.payment_status, "mb-6")}
        </div>
        <Card bg={"secondary"}>
          <CardBody className={"px-8 py-6"}>
            <RowModule customColumnCss={"col-md-6"} withoutSeparator={true}>
              <RowText
                label={t("total_bills")}
                value={toRupiah(detail?.billing_detail?.total_bill)}
              />
              <RowText
                label={t("remaining_bill")}
                value={toRupiah(detail?.billing_detail?.remaining_bill)}
              />
              <RowText
                label={t("already_paid")}
                value={toRupiah(detail?.billing_detail?.paid_amount)}
              />
              <RowText
                label={t("paid_date")}
                value={stringFormatting(
                  timeStampToDate(
                    detail?.billing_detail?.paid_date,
                    DATE_TYPE_ENUM.ISO_DATE_STRAP
                  )
                )}
              />
            </RowModule>
          </CardBody>
        </Card>
      </CardBody>
    </Card>
  )

  return (
    <>
      <div className={"row justify-content-center "}>
        <div className={" d-flex flex-column"} style={{ gap: 14 }}>
          {titleActivity}
          {detail?.billing_detail?.payment_status && bills}
          {detailActivitas}
        </div>
      </div>
      <Popup
        show={showPopup}
        title={`DETAIL ALSINTAN ${popupContent?.supplier_name?.toUpperCase()}`}
        bodyCustom={bodyPopup}
        textButton="Oke"
        onClick={() => {
          setShowPopup((Popup) => {
            !Popup
          })
        }}
      />
      <PopupQuestion
        onCancel={() => setShowModalDialog(false)}
        textCancel={t("button_cancel")}
        textOk={t("button_continue")}
        title={t("messages_title_activity_send_to_erp")}
        onOk={() => {
          dispatch(activitySendToErp(activity_id, {}))
          setShowModalDialog(false)
        }}
        show={showModalDialog}
        bodyCustom={
          <RowModule>
            <p className={"swal-text p-4"}>
              {t("messages_confirmation_activity_approve_to_erp_confirmation")}
            </p>
          </RowModule>
        }
      />
    </>
  )
}